import React, { useState, useEffect } from 'react'
import useJWT from "../../hooks/useJWT";
import useGetUser from '../../hooks/useGetUser';
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from 'sweetalert2'
import useUpdateProfile from '../../hooks/useUpdateProfile';

const schema = yup.object({
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    phoneNumber: yup.string().required(),
    email: yup.string().email().required(),
    userName: yup.string().required(),
    //address: yup.string(),
}).required();

const Profile = ({ }) => {
    const { user } = useJWT();
    //console.log(user);

    const { data, status, error, fetchUserGet } = useGetUser();
    const { data: dataUpdate, status: statusUpdate, error: errorUpdate, sentUpdateProfile } = useUpdateProfile();

    const {
        register,
        handleSubmit,
        reset,
        getValues,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        console.log(data);
        await sentUpdateProfile({
            userId: user.id,
            firstname: data.firstName,
            lastname: data.lastName,
            email: data.email,
            phone: data.phoneNumber,
            address: ""
        });
        // try {
        //     const result = await sentUpdateProfile({
        //         firstname: data.firstname,
        //         lastname: data.lastname,
        //         email: data.email,
        //         phone: data.phoneNumber,
        //         address: data.address
        //     });
        //     console.log(result);
        //     Swal.fire({
        //         title: "Success",
        //         text: "Save successfully",
        //         icon: "success"
        //     });
        // } catch (err) {
        //     console.log(err);
        //     Swal.fire({
        //         title: "Error",
        //         text: err.message,
        //         icon: "error"
        //     });
        // }
    };

    useEffect(() => {
        if (statusUpdate === "done") {
            console.log(dataUpdate);
            Swal.fire({
                title: "Success",
                text: "Save successfully",
                icon: "success"
            });
            fetchUserGet(user.id);
        } else if (statusUpdate === "error") {
            console.log(errorUpdate);
            Swal.fire({
                title: "Error",
                text: errorUpdate,
                icon: "error"
            });
        }
    }, [statusUpdate]);

    useEffect(() => {
        if (user && user.id) {
            fetchUserGet(user.id);
        }
    }, [user]);

    useEffect(() => {
        if (status === "done") {
            //console.log(data);
            setValue("firstName", data.firstName);
            setValue("lastName", data.lastName);
            setValue("phoneNumber", data.phoneNumber);
            setValue("email", data.email);
            setValue("userName", data.userName);
        }
    }, [status]);

    return (
        <section className='p-10'>
            <div className="container container-lg">
                <h6 className="text-xl pb-10 mb-10 d-flex align-items-center gap-12">
                    Profile
                </h6>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        {/* <div className="col-lg-12">
                            <div className="mb-24">
                                <div style={{
                                    width: "150px",
                                    height: "150px",
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                    backgroundColor: "#f1f1f1"
                                }}>
                                    <img src="assets/images/no-profile-picture.png" className="w-100 h-100 p-40" alt="" />
                                </div>
                                <button type="button" className="btn border border-main-one-600 text-main-one-600 mt-24">Change Picture</button>
                            </div>
                        </div> */}
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="mb-24">
                                <label
                                    htmlFor="userName"
                                    className="text-neutral-900 text-md mb-8 fw-medium"
                                >
                                    Username
                                </label>
                                <input
                                    disabled
                                    type="text"
                                    className="common-input"
                                    {...register("userName")}
                                    placeholder="Enter Username"
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">

                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="mb-24">
                                <label
                                    htmlFor="firstName"
                                    className="text-neutral-900 text-md mb-8 fw-medium"
                                >
                                    First Name
                                </label>
                                <input
                                    type="text"
                                    className="common-input"
                                    {...register("firstName")}
                                    placeholder="Enter First Name"
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="mb-24">
                                <label
                                    htmlFor="lastName"
                                    className="text-neutral-900 text-md mb-8 fw-medium"
                                >
                                    Last Name
                                </label>
                                <input
                                    type="text"
                                    className="common-input"
                                    {...register("lastName")}
                                    placeholder="Enter Last Name"
                                />
                            </div>
                        </div>
                        
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="mb-24">
                                <label
                                    htmlFor="email"
                                    className="text-neutral-900 text-md mb-8 fw-medium"
                                >
                                    Email Address
                                </label>
                                <input
                                    type="email"
                                    className="common-input"
                                    {...register("email")}
                                    placeholder="Enter Email Address"
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="mb-24">
                                <label
                                    htmlFor="phonenumber"
                                    className="text-neutral-900 text-md mb-8 fw-medium"
                                >
                                    Phone Number
                                </label>
                                <input
                                    type="text"
                                    className="common-input"
                                    {...register("phoneNumber")}
                                    placeholder="Enter Phone Number"
                                />
                            </div>
                        </div>
                        {/* <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="mb-24">
                                <label
                                    htmlFor="address"
                                    className="text-neutral-900 text-lg mb-8 fw-medium"
                                >
                                    Address
                                </label>
                                <textarea
                                    rows={5}
                                    className="common-input"
                                    {...register("address")}
                                    placeholder="Enter Address"
                                />
                                <div className='d-flex w-100 align-items-center gap-16'>
                                    <div className="form-check common-check common-radio py-16 mb-0">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="gender"
                                            id={"male"}
                                            checked
                                        // checked={selectedPayment === payment.id}
                                        // onChange={handlePaymentChange}
                                        />
                                        <label
                                            className="form-check-label fw-semibold text-neutral-600" style={{ width: "max-content" }}
                                            htmlFor={"male"}
                                        >
                                            Male
                                        </label>
                                    </div>
                                    <div className="form-check common-check common-radio py-16 mb-0">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="gender"
                                            id={"female"}
                                        // checked={selectedPayment === payment.id}
                                        // onChange={handlePaymentChange}
                                        />
                                        <label
                                            className="form-check-label fw-semibold text-neutral-600" style={{ width: "max-content" }}
                                            htmlFor={"female"}
                                        >
                                            Female
                                        </label>
                                    </div>
                                    <div className="form-check common-check common-radio py-16 mb-0">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="gender"
                                            id={"other"}
                                        // checked={selectedPayment === payment.id}
                                        // onChange={handlePaymentChange}
                                        />
                                        <label
                                            className="form-check-label fw-semibold text-neutral-600" style={{ width: "max-content" }}
                                            htmlFor={"other"}
                                        >
                                            Other
                                        </label>
                                    </div>
                                </div>

                            </div>
                        </div> */}
                    </div>
                    <button type="submit" disabled={statusUpdate === "loading"} className="btn bg-main-one-600 text-white px-64 mt-24">{statusUpdate === "loading" ? "Updating..." : "Update Profile"}</button>
                </form>
            </div>
        </section>
    )
}

export default Profile